<div class="breadcrumbs">
<med-breadcrumb>
    <ng-template
            medTemplate
            let-label
    >
        {{ label }}
    </ng-template>
</med-breadcrumb>
</div>
